import React from 'react';
import { Link } from 'react-router-dom';

const Top10Section = ({ items = [] }) => {
  if (items.length === 0) return null;

  return (
    <section className="py-8">
      <div className="max-w-[1800px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="flex items-center gap-4 mb-6">
          <div className="flex flex-col">
            <span style={{color:"var(--accent)"}} className="text-xs font-bold tracking-wider">TOP 10</span>
            <span className="text-white text-lg font-semibold">CONTENT</span>
            <span className="text-gray-400 text-xs">TODAY</span>
          </div>
        </div>

        {/* Horizontal Scroll Container */}
        <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide">
          {items.map((item) => (
            <Link
              key={item.id}
              to={`/${item.type}/${item.id}`}
              className="relative flex-shrink-0 group"
            >
              {/* Rank Number */}
              <div className="absolute -left-2 bottom-0 z-10">
                <span 
                  className="text-[80px] font-black leading-none"
                  style={{
                    WebkitTextStroke: '2px rgba(255,255,255,0.3)',
                    WebkitTextFillColor: 'transparent'
                  }}
                >
                  {item.rank}
                </span>
              </div>

              {/* Poster */}
              <div className="ml-8 w-28 h-40 rounded-lg overflow-hidden transition-transform duration-300 group-hover:scale-105">
                <img
                  src={item.poster}
                  alt={item.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/112x160?text=No+Image';
                  }}
                />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Top10Section;
